import React, { useState, useEffect } from 'react';
import axios from "@common/axios";
import { Input, Button, Spin, List, Typography, Space, Row, Col } from "antd";
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import useCurrentConcept from "@hooks/useCurrentConcept";

const { TextArea } = Input;
const { Title, Text } = Typography;

const circularIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const PromptSearch = props => {
    const {visible, setVisible} = props;
    const [prompt, setPrompt] = useState('');
    const [concepts, setConcepts] = useState();
    const [suggestions, setSuggestions] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const { loadCurrentConcept } = useCurrentConcept();

    const handleLoadQuery = () => {
        if (!prompt) {
            setConcepts(undefined);
            return;
        }

        setLoading(true);
        axios.get('/web/ui/search/searchContent', { params: { searchQuery: prompt } })
            .then(response => {
                setConcepts(response.data);
            })
            .catch(error => {
                console.error('Error loading search resources', error);
                setError('Failed to load search results.');
            })
            .finally(() => setLoading(false));
    };

    const handleSelectQuery = (value) => {
        setPrompt(value);
        handleLoadQuery();
    };

    const handleConceptClick = (conceptId) => {
        setVisible(false);
        loadCurrentConcept(conceptId);
    };

    useEffect(() => {
        if(!prompt) {
            setConcepts(undefined);
        }
    }, [prompt]);

    return (
        <div style={{ width: '100%' }}>
            <Space orientation="vertical" size="large" style={{ width: '100%' }}>
                <h3>Search Learning Resources</h3>
                <TextArea
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    placeholder="Enter your search query"
                    rows={4}
                    allowClear
                    style={{ width: '100%' }}
                />
                <div style={{ textAlign: 'right', width: '100%' }}>
                    <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={handleLoadQuery}
                        loading={loading}
                        disabled={!prompt || loading}
                        style={{ width: 'auto' }}
                    >
                        Search
                    </Button>
                </div>

                {loading && (
                    <div style={{ textAlign: 'center', marginTop: 16, width: '100%' }}>
                        <Spin indicator={circularIcon} />
                    </div>
                )}

                {!loading && concepts != undefined && concepts.length === 0 && prompt && (
                    <div className="ch-warning-text" style={{ width: '100%' }}>
                        <Text type="warning">No results found for your search</Text>
                    </div>
                )}

                {!loading && concepts == undefined && !prompt && (
                    <div className="ch-warning-text" style={{ width: '100%' }}>
                        <Text type="warning">Enter a search prompt</Text>
                    </div>
                )}

                {!loading && concepts == undefined && prompt && (
                    <div className="ch-warning-text" style={{ width: '100%' }}>
                        <Text type="warning">Click Search</Text>
                    </div>
                )}

                {!loading && concepts != undefined && concepts.length > 0 && (
                    <List
                        bordered
                        itemLayout="vertical"
                        dataSource={concepts}
                        style={{ width: '100%' }}
                        renderItem={concept => (
                            <List.Item key={concept.conceptId}>
                                <Space orientation="vertical" size="small" style={{ width: '100%' }}>
                                    <Title level={4}>
                                        {concept.syllabusName} - {concept.topicName} - {concept.conceptName}
                                    </Title>
                                    {concept.content && (
                                        <div className="ch-search-content" style={{ width: '100%' }}>
                                            <Text>{concept.content}</Text>
                                        </div>
                                    )}
                                    <Button type="link" onClick={() => handleConceptClick(concept.conceptId)}>
                                        Go to lesson
                                    </Button>
                                </Space>
                            </List.Item>
                        )}
                    />
                )}
            </Space>
        </div>
    );
};

export default PromptSearch;
